import * as React from "react";
const SvgWarningTriangle = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11 .5 0 20h22L11 .5ZM9.5 7h3v5h-3V7ZM11 18c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Z", fill: "#000" }));
export default SvgWarningTriangle;
